import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface DebriefParams {
    tracklogId: string;
    [otherParams: string]: string; // It bothers me that this is required
}

export function useDebriefRouter() {
    const params = useParams<DebriefParams>();
    const navigate = useNavigate();

    const getTracklogListRouteString = (): string => {
        return `/`;
    };

    const getTracklogRouteString = (tracklogId: string): string => {
        if (!tracklogId) return null;
        return `/${tracklogId}`;
    };

    const getDebriefRouteString = (tracklogId: string): string => {
        if (!tracklogId) return null;
        return `/${tracklogId}/debrief`;
    };

    const getSharedRouteString = (tracklogId: string): string => {
        if (!tracklogId) return null;
        return `/shared/${tracklogId}`;
    };

    return {
        routeParams: params,
        getTracklogListRouteString,
        getTracklogRouteString,
        getDebriefRouteString,
        getSharedRouteString,
    };
}

export default useDebriefRouter;
